<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';

import ButtonV2 from '../General/ButtonV2.vue';

interface Props {
    total?: number
    current?: number
    theme?: 'default' | 'primary' | 'secondary' | 'success' | 'info' | 'danger' | 'warning'
    darkMode?: boolean
}

const props = withDefaults(defineProps<Props>(), {
    total: 0,
    current: 0,
    theme: 'primary',
})
const emit = defineEmits(['change'])
const { t } = useI18n()
</script>
<template>
    <div class="flex gap-5 justify-between items-center">
        <ButtonV2 type="icon" :color="darkMode ? 'danger' : props.theme" animation
            @click="$emit('change', props.current - 1)" :disabled="props.current <= 0" :title="t(TEXT.prev_question)"
            class="shrink-0 py-2 px-5">
            <svg width="20" height="20" viewBox="0 0 25 34" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M1.9606 20.136C-0.0619848 18.5345 -0.0619805 15.4655 1.96061 13.864L17.7669 1.34864C20.3892 -0.727623 24.25 1.13995 24.25 4.48463L24.25 29.5154C24.25 32.8601 20.3892 34.7276 17.7669 32.6514L1.9606 20.136Z" />
            </svg>
        </ButtonV2>
        <div class="flex flex-col sm:flex-row gap-5 whitespace-pre">
            <div class="flex md:flex-col gap-1 items-center font-bold">
                <p class="text-orange-500 dark:text-rose-600 first-letter:capitalize">{{ t(TEXT.question) }}</p>
                <p class="text-black dark:text-zinc-700">{{ `${props.current + 1} / ${props.total}` }}</p>
            </div>
        </div>
        <ButtonV2 type="icon" :color="darkMode ? 'danger' : props.theme" animation
            @click="$emit('change', props.current + 1)" :disabled="props.current + 1 >= props.total"
            :title="t(TEXT.next_question)" class="shrink-0 py-2 px-5">
            <svg width="20" height="20" viewBox="0 0 25 34" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M23.0394 13.864C25.062 15.4655 25.062 18.5345 23.0394 20.136L7.23305 32.6514C4.61083 34.7276 0.75 32.8601 0.75 29.5154L0.75 4.48463C0.75 1.13994 4.61084 -0.72762 7.23306 1.34864L23.0394 13.864Z" />
            </svg>
        </ButtonV2>
    </div>
</template>